import {SaleStatus} from "./SaleStatus";

export const SaleStatusColors: Record<SaleStatus, "primary" | "secondary" | "info" | "warning" | "error" | "success" | "default"> = {
  [SaleStatus.BILLED]: "info",
  [SaleStatus.PENDING_COLLECTION]: "warning",
  [SaleStatus.CASHED]: "success",
  [SaleStatus.CASHED_IN_PROGRESS]: "secondary"
};
